import { combineReducers } from "redux";
 
import orderitem from "./orderItemsreducers";
import order from "./orderreducers";
import payment from "./paymentreducers";
 
export default combineReducers({
    orderitem,
    order,
    payment
});